<section class="section" id="form-landing-fru" [ngClass]="officeStatus?.answer ? '' : 'zero-padding'">
  <div class="container">
    @if (!calcSkin) {
      <h1 class="has-text-centered" [innerHTML]="headerText" style="color: #fff;"></h1>
    }

    <!-- ⚡ FAST mode opt-in card (FRU-21170) -->
    @if (!calcSkin) {
      <div class="fast-card" [class.is-on]="fastMode.enabled">
        <div class="fast-card-text">
          <div class="fast-title"><span class="fast-bolt">⚡</span>FAST</div>
          <div class="fast-sub">{{ fastMode.enabled ? "Now pick a loan type below to start" : "Skip the questions" }}</div>
        </div>
        <button type="button" class="fast-switch" (click)="toggleFast()"
          [attr.aria-pressed]="fastMode.enabled" [attr.aria-label]="fastMode.enabled ? 'Turn off FAST mode' : 'Turn on FAST mode'">
          <span class="fast-switch-bolt">⚡</span>
          <span class="fast-knob"></span>
        </button>
      </div>
    }

    <!-- FRU calc-skin: home-equity CALCULATOR landing. Digital screen + Calculate CTA (home equity pre-set, no loan-type choice). NO RATE. -->
    @if (calcSkin) {
      <div class="calc-landing" style="max-width:560px;margin:0 auto">
        <div class="calc-screen" style="background:linear-gradient(160deg,#1e2740,#0f1626);border-radius:16px;padding:20px 22px 24px;box-shadow:0 8px 30px rgba(15,22,38,.35);border:1px solid #2a3550">
          <div style="color:#8fa0c8;font-size:.72rem;font-weight:700;letter-spacing:1px;text-transform:uppercase;display:flex;align-items:center;gap:6px;margin-bottom:10px"><i class="fa fa-calculator"></i> Home Equity Calculator</div>
          <div style="color:#e8edf9;font-size:1.05rem;font-weight:700;line-height:1.25;margin:2px 0 14px">See how much home equity you may be able to access, then compare options from matched lenders.</div>
          <div>
            <span style="display:block;color:#e8edf9;font-size:1.05rem;font-weight:600;line-height:1.3">Answer a few quick questions to see how much you can access</span>
            <span style="display:block;color:#7d8aad;font-size:.66rem;margin-top:8px">estimate only, no obligation</span>
          </div>
        </div>
        <div style="text-align:center;margin-top:16px">
          <button type="button" (click)="calcContinue()" class="button continue is-large has-shadow-small" style="background:#2ecc71;color:#fff;border:none;border-radius:12px;padding:16px 34px;font-size:1.1rem;font-weight:800;box-shadow:0 4px 14px rgba(46,204,113,.35)">See What I Can Access&nbsp;<i class="fas fa-chevron-right"></i></button>
        </div>
      </div>
    }

    @if (!calcSkin) {
      <div class="columns is-centered">
        <div class="column">
          <div class="secure_form"><span><i class="fa fa-lock fa-lg"></i> Secure Form</span></div>

          <h2 class="has-text-centered has-text-grey-dark has-text-weight-semibold">
            Choose loan type
          </h2>

          <div class="buttons is-centered" [class.fast-pulse]="fastMode.enabled">
            <button (click)="redirectForm('refinance')" class="button icon-button icon-button-refinance">Refinance</button>
            <button (click)="redirectForm('purchase')" class="button icon-button icon-button-purchase">Purchase</button>
            <button (click)="redirectForm('refinance', 'heloc', 'homeequity')" class="button icon-button icon-button-heloc">Home Equity</button>
            <button (click)="redirectForm('refinance', 'cashout')" class="button icon-button icon-button-cash-out">Cash Out</button>
            <button (click)="redirectForm('refinance', 'homeimprovement')" class="button icon-button icon-button-home-improvement">Home Improvement</button>
          </div>
          <p   style="text-align: right">
            <a (click)="redirectForm('refinance', 'cashout', 'yes')" class="header-disclosure-link" style="color: #1e647f">
              Max Cash Out
            </a>
          </p>
        </div>
      </div>
    }
    <p style="text-align: center">
      <a (click)="adDisclosurePopup()" class="header-disclosure-link" style="color: #1e647f">
        * Advertising and Licensing Disclosures
      </a>
    </p>
  </div>
  @if (showTop10) {
    <div id="top10Container">
      <div id="top10">
        <app-lender-listings
          [initialState]="state"
          [officeStatus]="officeStatus"
          >
        </app-lender-listings>
      </div>
    </div>
  }
</section>
